<span (click)="alert('got clicked')" class='position-relative' [ngClass]="batterystat==3?'':levelValue==0?'battery danger':'battery success'" 
       [title]="batterystat==3?'':levelValue>=0?levelValue+'%':'Not available'">

                <ng-container  *ngIf="batterystat!=3;else external">
                <div *ngFor="let level of levelArr" 
                        [ngClass]="level=='on'?
                        levelValue<20?'bar active_red':
                        levelValue>=20&&levelValue<60?'bar active_amber':
                        levelValue>=60&&levelValue<=100?'bar active':'bar':'bar'" 
                        ></div>
                </ng-container>
                <ng-template #external >
                     <span  style="font-size: 10px;">Not Present</span>
                </ng-template>

         <fa-icon [icon]="faPlug" class="ml-2 position-absolute" style="left:110%;font-size: 10px;top:10%;" *ngIf="batterystat>0" 
                [title]="batterystat==3?'External source':''"
                ></fa-icon>
         <span class="font-monospace ml-2 position-absolute" style="left:130%;font-size: 10px;top:10%;" *ngIf="showLevel" >{{batterystat==3?'':levelValue>=0?levelValue+'%':'NA'}}</span>
</span>